module.exports = __webpack_public_path__ + "static/media/6C.3708c7e5.svg";